export default __webpack_public_path__ + "static/media/instagram.ef4f8981.png";